import React from 'react';
import { css } from '@emotion/react';

import NvTextArea from 'shared/components/inputs/nv-text-area';

import { gray5, white } from 'styles/global_defaults/colors';
import { quarterSpacing } from 'styles/global_defaults/scaffolding';

type EditableProps = {
  value: string,
  setValue: (value: string) => void,
};

const EditableSimpleInput = ({
  value,
  setValue,
}: EditableProps) => {
  const simpleTextStyles = css`
    width: 100%;
    .bs4-form-control {
      background: ${white};
    }
    .border-simple-text {
      border-radius: ${quarterSpacing}px;
      border-color: ${gray5};
    }
  `;
  return (
    <div css={simpleTextStyles} className='simple-text'>
      <NvTextArea
        value={value}
        autoComplete='off'
        textareaClassName='text-large-body border-simple-text'
        onChange={(e) => { setValue(e.currentTarget?.value); }}
      />
    </div>
  );
};

export default EditableSimpleInput;
